export const CHECKOUT_URL = 'https://aligner-en.impultienda.ar/checkout/'

export const HERO_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/bAousWk6k6zhfmcbXv8Xf3/ALINEADORES-EN.png'

export const AUTHOR_PHOTO =
  'https://cdn.magicpatterns.com/uploads/ibL1TxrB2CSnNPzRFiyUgQ/Dra._Karito_Odontologa.png'

export type Volume = {
  number: string
  title: string
  tagline: string
  description: string
  items: string[]
  note?: string
}

export const volumes: Volume[] = [
  {
    number: 'Volume I',
    title: 'Case Assessment',
    tagline: 'Organize your case evaluation before treatment begins.',
    description:
      'A practical framework for structuring your initial assessment, records, patient information, and key review points before moving into treatment planning.',
    items: [
      'Case Assessment Framework',
      'Initial Evaluation Checklist',
      'Records Checklist',
      'Case Information Sheet',
      'Pre-Planning Review',
      'Case Organization Map',
      'Assessment Worksheet',
    ],
  },
  {
    number: 'Volume II',
    title: 'Digital Planning',
    tagline: 'Turn case planning into a structured review process.',
    description:
      'Organize the key points you should review during digital treatment planning instead of relying on an improvised process.',
    items: [
      'Digital Planning Framework',
      'Planning Checklist',
      'Case Review Map',
      'Planning Worksheet',
      'Movement Review Framework',
      'Treatment Planning Tracker',
      'Pre-Approval Review Checklist',
    ],
  },
  {
    number: 'Volume III',
    title: 'Installation Control',
    tagline: 'Structure your aligner delivery and installation workflow.',
    description:
      'Organize the preparation, patient instructions, documentation, and review points surrounding aligner installation.',
    items: [
      'Pre-Installation Checklist',
      'Installation Workflow',
      'Patient Preparation Sheet',
      'Delivery Checklist',
      'Adaptation Review',
      'Documentation Checklist',
      'Installation Quick Reference',
    ],
  },
  {
    number: 'Volume IV',
    title: 'Attachments & IPR Control',
    tagline: 'Organize the critical stages surrounding attachments and IPR.',
    description:
      'A practical educational framework for structuring preparation, documentation, and review of procedures associated with aligner treatment.',
    items: [
      'Attachment Workflow',
      'Attachment Checklist',
      'Material Review Sheet',
      'IPR Planning Checklist',
      'IPR Documentation Sheet',
      'Pre-Procedure Checklist',
      'Post-Procedure Review',
      'Quick Reference Cards',
    ],
    note:
      'Always apply your professional judgment, training, manufacturer instructions, and applicable clinical regulations.',
  },
  {
    number: 'Volume V',
    title: 'Follow-Up & Case Control',
    tagline: 'Keep every case organized throughout treatment.',
    description:
      'Turn follow-up into a structured workflow with tools designed to help you document progress, organize appointments, and identify when professional reassessment may be appropriate.',
    items: [
      'Patient Progress Tracker',
      'Follow-Up Checklist',
      'Control Visit Sheet',
      'Case Review Framework',
      'Documentation Tracker',
      'Progress Monitoring Sheet',
      'Case Timeline',
      'Review Questions',
    ],
  },
  {
    number: 'Volume VI',
    title: 'Refinement & Finishing',
    tagline: 'Structure the final stages of your aligner cases.',
    description:
      'A practical framework for organizing reassessment, documentation, refinement planning, and treatment completion.',
    items: [
      'Refinement Review Framework',
      'Case Reassessment Sheet',
      'Refinement Checklist',
      'Finishing Checklist',
      'Final Documentation Sheet',
      'Treatment Completion Review',
      'Retention Planning Checklist',
      'Final Case Summary',
    ],
  },
]

export type Bonus = {
  label: string
  title: string
  value: string
  description: string
  items?: string[]
  footer?: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    label: 'Bonus #1',
    title: 'Aligner Quick Reference Cards™',
    value: '$37',
    description:
      'A collection of visual quick-reference cards covering key stages of the aligner workflow.',
    items: [
      'Case Assessment',
      'Digital Planning',
      'Installation',
      'Attachments',
      'IPR',
      'Follow-Up',
      'Refinement',
      'Finishing',
    ],
    footer: 'Designed to help you find the relevant framework quickly.',
    image:
      'https://cdn.magicpatterns.com/uploads/4NnypP672yp2vZPaXVea6r/BONUS_1_ALINEADORES-EN.png',
  },
  {
    label: 'Bonus #2',
    title: 'Case Control Tracker™',
    value: '$37',
    description:
      'A complete collection of tracking sheets designed to help you organize each case from initial assessment through completion.',
    items: [
      'Case Timeline',
      'Patient Progress Tracker',
      'Follow-Up Tracker',
      'Documentation Tracker',
      'Case Review Sheet',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/bB8NbwybTm8UuKDHBnX5mL/BONUS_2_ALINEADORES-EN.png',
  },
  {
    label: 'Bonus #3',
    title: 'Pre-Installation Master Checklist™',
    value: '$27',
    description:
      'A structured preparation checklist for organizing the key points to review before an aligner installation appointment.',
    footer:
      'Designed to help you create a more consistent preparation process instead of relying entirely on memory.',
    image:
      'https://cdn.magicpatterns.com/uploads/gLZmJBVYgmhW8uYvSGKmoY/BONUS_3_ALINEADORES-EN.png',
  },
  {
    label: 'Bonus #4',
    title: 'Refinement Review Kit™',
    value: '$37',
    description:
      'A collection of tools for structuring the review of cases that require reassessment and potential refinement planning.',
    items: [
      'Case Review Sheet',
      'Refinement Checklist',
      'Documentation Sheet',
      'Review Questions',
      'Refinement Planning Framework',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/dnMESkvuFs1Rw4tJgQ9DkR/BONUS_4_ALINEADORES-EN.png',
  },
  {
    label: 'Bonus #5',
    title: 'Aligner Clinical Desk™',
    value: '$29',
    description:
      'A visual toolkit designed to keep the most important ALIGNER CONTROL SYSTEM™ resources within easy reach.',
    items: [
      'Treatment Journey Poster',
      'Quick Workflow',
      'Case Control Map',
      'Installation Card',
      'Control Card',
      'Refinement Card',
      'Finishing Card',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/fbkZQLh9WRDF9VELR7oneD/BONUS_5_ALINEADORES-EN.png',
  },
]

export const beforeItems = [
  'You spend time searching through different notes and resources.',
  'You have too many things to remember before an installation.',
  'You are not always sure what to review at each stage.',
  'Your follow-up process depends heavily on memory.',
  'Complex cases require you to go back to multiple sources.',
  'You don’t have a standardized workflow.',
  'Every case ends up being managed differently.',
]

export const afterItems = [
  'You follow a structured workflow from assessment to finishing.',
  'You use checklists for key stages.',
  'You organize the case before moving forward.',
  'You have dedicated tools for case tracking.',
  'You can quickly find what you need to review.',
  'You create greater consistency in your workflow.',
  'You turn information into an organized clinical system.',
]

export const painPoints = [
  {
    icon: '😰',
    text:
      'You have an aligner case in front of you and want a clearer structure for what to review before getting started.',
  },
  {
    icon: '⏱️',
    text:
      'You spend too much time going back through courses, notes, PDFs, and different resources.',
  },
  {
    icon: '🤔',
    text:
      'Before an installation, you want to make sure you are not overlooking an important step.',
  },
  {
    icon: '📋',
    text:
      'You don’t have a practical checklist covering the different stages of the treatment.',
  },
  {
    icon: '🔄',
    text:
      'When a case requires follow-up or reassessment, you have to go back and reconstruct the entire case.',
  },
  {
    icon: '😓',
    text:
      'You know you need more structure in your aligner workflow, but you don’t want to spend hours creating your own protocols.',
  },
]

export const controlCenter = [
  {
    emoji: '📝',
    title: '30+ Protocols & Checklists',
    text:
      'Practical educational checklists covering the major stages of the aligner workflow.',
  },
  {
    emoji: '📋',
    title: 'Case Control Tools',
    text:
      'Organize assessment, planning, installation, follow-up, refinement, and finishing.',
  },
  {
    emoji: '🧭',
    title: 'Decision Maps',
    text:
      'Visual frameworks that help structure what information to review and which questions to consider at different stages.',
  },
  {
    emoji: '📊',
    title: 'Case Trackers',
    text: 'Keep your case information, progress, and review points organized.',
  },
  {
    emoji: '📸',
    title: 'Documentation Tools',
    text: 'Structure your clinical documentation and case review process.',
  },
  {
    emoji: '⚡',
    title: 'Quick Reference System',
    text:
      'Find the tool you need without having to search through an entire manual.',
  },
]

export const pillars = [
  { title: 'Consult', text: 'Find the resource you need.' },
  { title: 'Organize', text: 'Follow a structured workflow.' },
  { title: 'Check', text: 'Use practical checklists at key stages.' },
  { title: 'Document', text: 'Keep your case information organized.' },
  { title: 'Review', text: 'Structure your follow-up and reassessment process.' },
  { title: 'Plan', text: 'Turn scattered information into an organized workflow.' },
]

export const steps = [
  { step: 'Step 1', title: 'Assess', text: 'Start with the Case Assessment Framework.' },
  { step: 'Step 2', title: 'Plan', text: 'Move through the Digital Planning Framework.' },
  { step: 'Step 3', title: 'Prepare', text: 'Use the preparation checklists before installation.' },
  { step: 'Step 4', title: 'Control', text: 'Track the case using the Case Control System.' },
  { step: 'Step 5', title: 'Review', text: 'Use the follow-up and reassessment tools.' },
  { step: 'Step 6', title: 'Refine', text: 'Organize the refinement and finishing stages.' },
]

export const rememberItems = [
  'Case assessment',
  'Records',
  'Digital planning',
  'Installation',
  'Attachments',
  'IPR',
  'Follow-up',
  'Progress monitoring',
  'Refinement',
  'Finishing',
]

export type Testimonial = {
  name: string
  role: string
  location: string
  photo: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Dr. Sofía Ramírez',
    role: 'General Dentist',
    location: 'Monterrey, MX',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/9812ad27-c711-46e5-b15d-b5864df380ea.jpg',
    quote:
      'I used to open three different folders before every installation. Now I print one checklist and the appointment runs the same way every time.',
  },
  {
    name: 'Dr. Andrés Gutiérrez',
    role: 'Aligner Provider',
    location: 'Bogotá, CO',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/aff2a97e-1a52-42a5-8323-752926693b3f.jpg',
    quote:
      'The digital planning review map alone was worth it. I stopped approving plans with the feeling that I had missed something.',
  },
  {
    name: 'Dr. Lucía Ferrer',
    role: 'Orthodontist',
    location: 'Valencia, ES',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/12a1d637-01e2-4bf9-9872-eaeccb5f93af.jpg',
    quote:
      'My follow-up visits used to depend on memory. With the progress tracker I can see the whole case history in one page.',
  },
  {
    name: 'Dr. Martín Salazar',
    role: 'General Dentist',
    location: 'Santiago, CL',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/a8f8b6f8-fd9b-4128-a342-d50e3f584c98.jpg',
    quote:
      'I organized my first case in about twelve minutes. It is not more information, it is the structure I was missing.',
  },
  {
    name: 'Dr. Camila Duarte',
    role: 'Clinic Owner',
    location: 'Panama City, PA',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/bc91f713-f775-4eb4-a81b-4e1b047d00c6.jpg',
    quote:
      'My whole team now follows the same workflow. Every aligner case in the clinic is documented the same way.',
  },
]

export const faqs = [
  {
    q: 'How will I receive the material?',
    a: 'After completing your purchase, you’ll receive instructions to access and download the digital materials.',
  },
  {
    q: 'Is this a course?',
    a: 'No. ALIGNER CONTROL SYSTEM™ is a digital clinical organization and reference system consisting of 6 volumes, protocols, checklists, trackers, frameworks, and practical tools.',
  },
  {
    q: 'Is this suitable for general dentists?',
    a: 'The system is designed for dental professionals who work with or are interested in working with aligners. The materials are educational and do not replace professional education, diagnosis, clinical judgment, manufacturer instructions, or applicable regulations.',
  },
  {
    q: 'Does the offer include all 6 volumes?',
    a: 'Yes. Your purchase includes all 6 volumes of ALIGNER CONTROL SYSTEM™, plus the 5 professional bonuses.',
  },
  {
    q: 'Are the materials downloadable?',
    a: 'Yes. The materials are delivered digitally and can be downloaded according to the access conditions of the offer.',
  },
  {
    q: 'Is this a one-time payment?',
    a: 'Yes. You pay $27 once. There are no recurring monthly fees.',
  },
  {
    q: 'Do I get lifetime access?',
    a: 'Yes, according to the access conditions of the offer.',
  },
  {
    q: 'Can I use the system in any country?',
    a: 'The system is designed as an educational and organizational resource. Clinical procedures must always be performed according to your professional training, applicable laws and regulations, manufacturer instructions, and local clinical standards. Currency is converted automatically at checkout.',
  },
  {
    q: 'What if I don’t like it?',
    a: 'You have a 7-day guarantee according to the terms of the offer.',
  },
]

export const buyerPopups = [
  { name: 'Valeria M.', country: 'Mexico' },
  { name: 'Jorge L.', country: 'Colombia' },
  { name: 'Antonella R.', country: 'Argentina' },
  { name: 'Diego S.', country: 'Chile' },
  { name: 'Paula C.', country: 'Spain' },
  { name: 'Ricardo T.', country: 'Peru' },
  { name: 'Mariana G.', country: 'Ecuador' },
  { name: 'Fernando V.', country: 'Uruguay' },
  { name: 'Daniela P.', country: 'Costa Rica' },
  { name: 'Sebastián A.', country: 'Dominican Republic' },
  { name: 'Lucía N.', country: 'Guatemala' },
  { name: 'Héctor B.', country: 'Panama' },
]
